<div class="adv ">
    <div class="relative mt-6 mb-6 overflow-hidden min-h-36" >
        <div class="carousel-container" #carouselContainer>
            <div class="carousel-track flex transition-transform duration-300" #carouselTrack>
                <div *ngFor="let ad of advertisements; let i = index" class="carousel-item min-w-full px-2">
                    <div  class="p-5 .glass-effect text-white text-center" >
                        <h1>{{ad.title}}</h1>
                       <p class="text-2xl">{{ad.description}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Indicator Dots -->
        <div class="absolute bottom-1 left-0 right-0 flex justify-center pb-2">
            <div *ngFor="let ad of advertisements; let i = index"
                class="mx-1 w-2 h-2 rounded-full transition-all duration-200"
                [ngClass]="{'bg-black': currentSlide === i, 'bg-gray-300': currentSlide !== i}"
                (click)="goToSlide(i)">
            </div>
        </div>
    </div>
</div>